export function preprocessParagraphLine(line) {
  return String(line ?? '')
    .replace(/\[\d+\]/g, '')
    .replace(/\s+/g, '')
    .replace(/["'\u2018\u2019\u201C\u201D「」『』]/g, '')
    .replace(/;/g, '；');
}

export function preprocessParagraphText(raw) {
  return String(raw ?? '')
    .split(/\r\n|\n|\r/)
    .map(preprocessParagraphLine)
    .filter((line) => line.length > 0)
    .join('\n');
}

const SENTENCE_CUT_DELIMITERS = /(?<=[。！？；])/;

/** Pre-process each input line, flatten, then cut into one sentence per line. */
export function cutTextBySentencePunctuation(text) {
  const cleaned = String(text ?? '')
    .split(/\r\n|\n|\r/)
    .map(preprocessParagraphLine)
    .filter(Boolean)
    .join('');
  if (!cleaned) return '';
  return cleaned
    .split(SENTENCE_CUT_DELIMITERS)
    .map((part) => part.trim())
    .filter(Boolean)
    .join('\n');
}
